import styled from 'styled-components';

const lightRed = '#DE3E4D';

export const IntroductionPageWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0px;
    height: calc(100vh - 20px);
    width: 100%;

    @media screen and (max-width: 992px){
        padding: 10px 15px;
        width: calc(100% - 30px);
    }
`;

export const IntroductionPageLogo = styled.span`
    color: ${lightRed};
    font-weight: 700;
    font-size: 35px;

    @media screen and (max-width: 576px) {
        font-size: 30px;
    }
`;

export const IntroductionPageDescription = styled.span`
    color: #898989;
    font-style: italic;
`;

export const IntrodutionPageActionWrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    font-size: 25px;
    font-family: 'Rubik', sans-serif;
    
    & > span {
        align-self: flex-start;
        font-weight: 500;

        &:nth-child(1) {
            margin: 0px 0px 5px 0px;
        }

        &:nth-child(2) {
            font-size:18px;
            color: grey;
            margin: 0px 0px 30px 0px;

            & > i {
                font-style: normal;
                font-weight: 500;
                color: ${lightRed} ;
            }
        }
    }

    & > button {
        align-self: center;
    }

    @media screen and (max-width: 576px){
        width: 100%;
    }
`;

export const IntroductionPageActionButtons = styled.div`
    display: flex;
    justify-content: center;
    margin: 20px 0px 0px 0px;

    & > button {
        margin: 0px 15px;
    }
`;